module.exports = __webpack_public_path__ + "img/tm.a1c18f1a.svg";